import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getListAddBlackListsSuccess,
  getListAddBlackListsFailed,
  GET_LIST_ADD_BLACKLIST_START,
} from '../../actions/blackList'
import { api } from '~/services/api'

/**
 * get list add blacklist api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListAddBlackListsApi = (props) => {
  var uri = `/sponsor-tournament-blacklist/users`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetAddBlackLists(action) {
  try {
    const response = yield call(getListAddBlackListsApi, action?.payload)
    yield put(getListAddBlackListsSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getListAddBlackListsFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list add blacklist
 */
export default function* watchGetAddBlackLists() {
  yield takeLatest(GET_LIST_ADD_BLACKLIST_START, doGetAddBlackLists)
}
